export const SentimentDot = ({ sentiment, testId }) => {
  if (sentiment !== "positive" && sentiment !== "negative") return null;
  const color = sentiment === "positive" ? "#3BB273" : "#E63946";
  return (
    <span
      className="inline-block w-[6px] h-[6px] rounded-full flex-shrink-0"
      style={{ background: color }}
      title={sentiment === "positive" ? "Positive tone" : "Negative tone"}
      aria-label={sentiment === "positive" ? "Positive tone" : "Negative tone"}
      data-testid={testId || `sentiment-dot-${sentiment}`}
    />
  );
};
